"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiSwitch = getMuiSwitch;
var _constants = require("../../../constants");
function getMuiSwitch() {
  return {
    styleOverrides: {
      root: function (_ref) {
        var theme = _ref.theme;
        return {
          '&:focus': {
            backgroundColor: theme.palette.gray[500],
            borderRadius: 12,
            boxShadow: "0px 0px 0px 4px ".concat(theme.palette.primary[100])
          },
          '&:focus-within': {
            backgroundColor: theme.palette.gray[500],
            borderRadius: 12,
            boxShadow: "0px 0px 0px 4px ".concat(theme.palette.primary[100]),
            height: 'inherit',
            width: 'inherit'
          },
          '&:hover': {
            '.MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track': {
              backgroundColor: theme.palette.mode === 'dark' ? theme.palette.primary[300] : theme.palette.primary[700]
            },
            '.MuiSwitch-track': {
              backgroundColor: theme.palette.mode === 'dark' ? theme.palette.primary[200] : theme.palette.gray[500]
            },
            backgroundColor: theme.palette.gray[500],
            borderRadius: 12
          },
          '.Mui-disabled .MuiSwitch-thumb': {
            backgroundColor: "".concat(theme.palette.gray[50], " !important"),
            boxShadow: theme.shadows[_constants.SHADOWS.sm],
            opacity: '1 !important'
          },
          '.Mui-disabled+ .MuiSwitch-track': {
            backgroundColor: "".concat(theme.palette.gray[200], "!important"),
            opacity: '1 !important'
          },
          '.Mui-disabled.Mui-checked .MuiSwitch-thumb': {
            backgroundColor: "".concat(theme.palette.gray[50], " !important"),
            boxShadow: theme.shadows[_constants.SHADOWS.sm]
          },
          '.Mui-disabled.Mui-checked+ .MuiSwitch-track': {
            backgroundColor: "".concat(theme.palette.gray[100], " !important")
          },
          '.MuiSwitch-switchBase': {
            '&.Mui-checked': {
              '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.mode === 'dark' ? theme.palette.primary[200] : theme.palette.primary[600],
                opacity: 1
              },
              '& .MuiSwitch-track:hover': {
                backgroundColor: theme.palette.mode === 'dark' ? theme.palette.primary[300] : theme.palette.primary[700],
                opacity: 1
              },
              transform: 'translateX(20px)'
            },
            '&:hover': {
              backgroundColor: 'transparent'
            },
            padding: 2
          },
          '.MuiSwitch-thumb': {
            backgroundColor: theme.palette.common.white,
            boxShadow: theme.shadows[_constants.SHADOWS.sm],
            height: 20,
            width: 20
          },
          '.MuiSwitch-track': {
            '.Mui-checked': {
              '&:hover': {
                backgroundColor: theme.palette.mode === 'dark' ? theme.palette.primary[300] : theme.palette.primary[700]
              }
            },
            backgroundColor: theme.palette.mode === 'dark' ? theme.palette.gray[100] : theme.palette.gray[400],
            borderRadius: 12,
            height: 24,
            padding: 2,
            width: 44
          },
          backgroundColor: theme.palette.gray[400],
          borderRadius: 12,
          height: 24,
          padding: 0,
          width: 44
        };
      },
      sizeSmall: {
        '.MuiSwitch-switchBase': {
          '&.Mui-checked': {
            transform: 'translateX(16px)'
          }
        },
        '.MuiSwitch-thumb': {
          height: 16,
          width: 16
        },
        '.MuiSwitch-track': {
          height: 20,
          width: 36
        },
        height: 20,
        width: 36
      }
    }
  };
}